import React from 'react'
import { Button as AntButton, Input, message } from 'antd'
import { customPhotoUploadApi } from '../../api'

export default function AddImage({ imageList, setImageList }) {
	const handleFileChange = (event, index) => {
		const updatedImageList = [...imageList]
		updatedImageList[index].file = event.target.files[0]
		setImageList(updatedImageList)
	}

	const uploadImg = async (index) => {
		const image = imageList[index]
		const updatedImageList = [...imageList]
		updatedImageList[index].uploadLoading = true
		setImageList(updatedImageList)

		if (!image.file) {
			message.error('Фотография не выбрано')
			return
		}

		const formData = new FormData()
		formData.append('file', image.file)

		const generateRandomKey = () => {
			const characters =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			let randomKey = ''
			for (let i = 0; i < 16; i++) {
				randomKey += characters.charAt(
					Math.floor(Math.random() * characters.length),
				)
			}
			return randomKey
		}

		const randomKey = generateRandomKey()
		const title = 'YourTitle' // Replace with actual title

		formData.append('Title', title)
		formData.append('Key', randomKey)

		try {
			const res = await customPhotoUploadApi.post('assets/upload', formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})

			const { key } = res.data
			updatedImageList[index].path = key
			setImageList(updatedImageList)

			message.success('Успешно загружено!')
		} catch (err) {
			message.error('Ошибка загрузки')
		} finally {
			const updatedImageList = [...imageList]
			updatedImageList[index].uploadLoading = false
			setImageList(updatedImageList)
		}
	}

	const viewImage = async (index) => {
		const image = imageList[index]
		const updatedImageList = [...imageList]
		updatedImageList[index].viewLoading = true
		setImageList(updatedImageList)
		try {
			const res = await customPhotoUploadApi.get(
				`assets/download/${image.path}`,
				{
					responseType: 'blob',
				},
			)

			const url = window.URL.createObjectURL(
				new Blob([res.data], {
					type: 'image/png',
				}),
			)

			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', 'BP.png')
			document.body.appendChild(link)
			link.click()

			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		} catch (error) {
			message.error('Ошибка загрузки файла')
		} finally {
			const updatedImageList = [...imageList]
			updatedImageList[index].viewLoading = false
			setImageList(updatedImageList)
		}
	}

	const addNewRow = () => {
		setImageList([...imageList, { file: null, path: '', imgLoading: false }])
	}

	const deleteRow = (index) => {
		setImageList(imageList.filter((_, i) => i !== index))
	}
	return (
		<div className="w-full sm:w-[600px]">
			{imageList.map((image, index) => (
				<div
					key={index}
					className="flex flex-col w-full items-start gap-3 mt-5 mb-10"
				>
					<div>
						<p className="font-bold">Фото-{index + 1}</p>
					</div>
					<div className="flex flex-col sm:flex-row items-center gap-3">
						<Input
							type="file"
							onChange={(e) => handleFileChange(e, index)}
							className="w-full"
						/>
						<AntButton
							onClick={() => uploadImg(index)}
							loading={image.uploadLoading}
							className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
						>
							Загрузить
						</AntButton>
						{image.path && (
							<AntButton
								onClick={() => viewImage(index)}
								loading={image.viewLoading}
								className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
							>
								Скачать
							</AntButton>
						)}
						{index !== 0 && (
							<AntButton
								onClick={() => deleteRow(index)}
								className="h-10 w-full sm:w-[100px] rounded-lg p-2 bg-red-500 text-white"
							>
								Удалить
							</AntButton>
						)}

						{index === imageList.length - 1 && (
							<AntButton
								onClick={addNewRow}
								className="h-10 w-full sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
							>
								Добавить
							</AntButton>
						)}
					</div>
				</div>
			))}
		</div>
	)
}
